export const STANDARD_ICONS_LIST = [
    ...Array.from({ length: 50 }, (_, i) => `man_${i + 1}`),
    ...Array.from({ length: 50 }, (_, i) => `woman_${i + 1}`),
    '',
    '',
];

export const KIDS_ICONS_LIST = [
    ...Array.from({ length: 40 }, (_, i) => `boy_${i + 1}`),
    ...Array.from({ length: 38 }, (_, i) => `girl_${i + 1}`),
];
